import VueCookies from 'vue-cookies';
import RefappUserRedirect from './components/refapp-user-redirect.vue';
import RefappRedirectOptions from './components/base/refapp-redirect-options.vue';

export default {
  install(app) {
    const components = [RefappUserRedirect, RefappRedirectOptions];
    if (!app.$cookies) app.use(VueCookies);
    components.forEach((c) => app.component(c.name, c));
  },
};
